export default __webpack_public_path__ + "static/media/port2.4aa0b2ba.jpg";